<template>
  <v-container>
    <component  :is="'script'" type="application/ld+json">
      {
        "@context": "https://schema.org",
        "@type": "Article",
        "mainEntityOfPage":"https://hot-linux.dev/sales",
        "headline":"Hot Linux ／ WEBシステム開発（販売商品）",
        "description":"Hot Linuxでは小規模WEBシステム開発やPHPプログラミングのアドバイスを中心にお引き受けしております。法人様だけでなく個人事業主様・個人様からの相談も大歓迎です。このページではすぐにご購入いただけるサービスを紹介しています。かなりリーズナブルな価格でご提供しています。ご購入前のご相談も受け付けております。",
        "image":[
          "https://hot-linux.dev/img/hot-linux-logos_purple.de39c269.webp"
        ],
        "author":{
          "@type":"Person",
          "name":"山田昌史",
          "url":"https://hot-linux.dev/"
        }
      }
    </component>
    <v-row>
      <v-col cols="12" md="6">
        <left-side>
        </left-side>
      </v-col>
      <v-col cols="12" md="6">
        <v-breadcrumbs
          icon="mdi-cart-outline"
          bg-color="grey-lighten-4"
          rounded
        >
          <h3>販売商品</h3>
        </v-breadcrumbs>
        <v-card v-for='(row,index) in 販売商品rtn' :key='index' class='mx-3 my-3'>
          <template v-slot:title>
            <v-list>
              <v-list-item
                :href="row.サンプルpath"
                target="_blank"
                style='white-space:normal'
              >
                {{row.タイトル}}
              </v-list-item>
            </v-list>
          </template>
          <v-card-subtitle>
            {{row.サブタイトル}}
          </v-card-subtitle>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <template v-if="row.画像">
                  <v-img class='mx-5'
                    :src='require("/src/assets/"+row.画像)'
                  ></v-img>
                </template>
              </v-col>
              <v-col cols="12" md="6">
                <v-row>
                <span v-html='row.テキスト'></span>
                </v-row>
                <v-row> 
                  <v-col class='text-right text-h5'>
                    {{Number(row.金額).toLocaleString('ja-JP', { style: 'currency', currency: 'JPY' })}}
                    <div class='text-body-1'>（税込 {{Number(row.金額*1.1).toLocaleString('ja-JP', { style: 'currency', currency: 'JPY' })}}）</div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-btn
              block
              class='mb-8'
              color='primary'
              variant="elevated"
              @click='詳細表示(row)'>詳しくみる
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model='showSalesDialog'
      max-width='800'
      class="overflow-y-hidden"
    >
      <v-card
        class="overflow-y-hidden"
      >
        <v-card-title>
          {{selectedRow.タイトル}}
        </v-card-title>
        <v-card-text
          class="overflow-y-auto"
        >
          <v-row>
            <v-col cols="12" md="4">
              <template v-if="selectedRow.画像">
                <v-img class='mx-5'
                  :src='require("/src/assets/"+selectedRow.画像)'
                ></v-img>
              </template>
            </v-col>
            <v-col cols="12" md="8">
              <span v-html='selectedRow.テキスト'></span>
            </v-col>
          </v-row>
          <!--
          <stripe-checkout
            ref="checkoutRef"
            mode="payment"
            :pk="publishableKey"
            :line-items="lineItems"
            :success-url="successURL"
            :cancel-url="cancelURL"
            @loading="v => loading = v"
          >
          </stripe-checkout>
          -->
        </v-card-text>
        <v-card-actions>
          <v-row>
            <v-col cols="4">
              <v-btn

                class='secondary'
                @click='閉じる()'
                block
              >閉じる</v-btn>
            </v-col>
            <v-col cols=8>
              <v-btn
                color='primary'
                @click='支払処理()'
                block
              >お支払い手続きへ</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>
<script>
  import LeftSide from './LeftSide.vue';
  //import { StripeCheckout } from '@vue-stripe/vue-stripe';

  export default {
    components: {
      LeftSide,
      //StripeCheckout,
    },
    data(){
      return {
        publishableKey:"pk_live_51LqaOxBsJ7h6wFC2VbWfngH6kaeFqppgTZhksVqv9EM1ymsntptZLqWeGukZBFypsbupABvEYsf1NEIMKB7okGS400UsJ8ph5E",
        panel:false,
        販売商品rtn:[],
        showSalesDialog:false,
        selectedRow:{},

        lineItems:[
          {
            price: "", // The id of the one-time price you created in your Stripe dashboard
            quantity: 1,
          },
        ],
        successURL:"https://hot-linux.dev/sales",
        cancelURL:"https://hot-linux.dev/sales",
      }
    },
    created(){
    },
    mounted(){
      this.販売商品取得();
    },

    methods:{
      販売商品取得(){
        this.$emit('overlay');
        let url = './api/api.php';
        let data = {
          func:"販売商品取得",
          pageSize:15,
        };

       let param = {
          method : "POST",
          headers : { "Content-Type": "application/json" },
          body : JSON.stringify(data),
        }
        fetch(url,param)
        .then(response => {return response.text();})
        .then(result => {
          try {
            const jsonData = JSON.parse(result);
            return jsonData;
          }catch(e){
            return Promise.reject({body:result,type:'unparsable'})
          }
        })
        .then(result => {
          this.販売商品rtn = result.販売商品rtn;
          this.$emit('overlay');
        })
        .catch(error =>{
          console.log(error)
          alert('取得できませんでした。\n\n'+error.body);
          this.$emit('overlay');
        })
      },

      詳細表示(row){
        console.log("row",row)

        this.selectedRow = row
        this.lineItems[0].price = this.selectedRow.price_id

        this.showSalesDialog = true
      },

    支払処理(){
      console.log("price_id",this.selectedRow.price_id)
      console.log("lineItems",this.selectedRow.lineItems)

      //this.$refs.checkoutRef.redirectToCheckout();
      window.open(this.selectedRow.支払いurl,"支払い")
    },

      閉じる(){
        this.showSalesDialog = false
      }

    },
  }
</script>

  